module.exports = __webpack_public_path__ + "static/media/void-awaits.bdef826e.jpg";